import {
  GET_SOURCE_SETTINGS_STICKY_COLUMNS,
  GET_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS,
  GET_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR,
  UPDATE_SOURCE_SETTING_STICKY_COLUMNS,
  UPDATE_SOURCE_SETTING_STICKY_COLUMNS_SUCCESS,
  UPDATE_SOURCE_SETTING_STICKY_COLUMNS_ERROR,
  GET_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS,
  GET_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS,
  GET_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR,
  UPDATE_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS,
  UPDATE_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS,
  UPDATE_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR,
  GET_CALL_SOURCE_SETTINGS_STICKY_COLUMNS,
  GET_CALL_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS,
  GET_CALL_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR,
  UPDATE_CALL_SOURCE_SETTINGS_STICKY_COLUMNS,
  UPDATE_CALL_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS,
  UPDATE_CALL_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR
} from "./actionTypes"

const initialState = {
  error: null,
  user_column_preference_source_setting: null,
  loading: false,
  user_column_preference_call_source_setting: null,
  user_column_preference_lead_source_setting: null,
}

const UserSourceSettingsColumnPreference = (state = initialState, action) => {
  switch (action.type) {
    case GET_SOURCE_SETTINGS_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case GET_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_source_setting: action.payload,
        loading: false
      }

    case GET_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case UPDATE_SOURCE_SETTING_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case UPDATE_SOURCE_SETTING_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_source_setting: action.payload,
        loading: false
      }

    case UPDATE_SOURCE_SETTING_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
      // lead source settings
    case GET_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS:
        return {
          ...state,
          loading: true
        }
  
    case GET_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS:
        return {
          ...state,
          user_column_preference_lead_source_setting: action.payload,
          loading: false
        }
  
    case GET_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR:
        return {
          ...state,
          error: action.payload,
          loading: false
        }
  
    case UPDATE_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS:
        return {
          ...state,
          loading: true
        }
  
    case UPDATE_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS:
        return {
          ...state,
          user_column_preference_lead_source_setting: action.payload,
          loading: false
        }
  
    case UPDATE_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR:
        return {
          ...state,
          error: action.payload,
          loading: false
        }
      // call source settings
    case GET_CALL_SOURCE_SETTINGS_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case GET_CALL_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_call_source_setting: action.payload,
        loading: false
      }

    case GET_CALL_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case UPDATE_CALL_SOURCE_SETTINGS_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case UPDATE_CALL_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_call_source_setting: action.payload,
        loading: false
      }

    case UPDATE_CALL_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
    }
    default:
      return state
  }
}

export default UserSourceSettingsColumnPreference;
